import { useEffect } from 'react';

const useEscapeKey = (callback, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') callback();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [callback, enabled]);
};

export default useEscapeKey;
